import { configureStore } from "@reduxjs/toolkit";
import { createHashHistory } from "history";
import { createLogger } from "redux-logger";
import createRootReducer from "../reducers";

export const history = createHashHistory();

const rootReducer = createRootReducer();

export const configureAppStore = (preloadedState: any) => {
  const logger = createLogger({
    level: "info",
    collapsed: true,
  });

  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    // DevTools are enabled by default in development with RTK.
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware: any) => {
      const middleware = getDefaultMiddleware({
        // adjust if you store non-serializable stuff in state/actions
        serializableCheck: false,
      });

      // Skip redux logs in console during the tests
      return process.env.NODE_ENV == "test" ?  middleware : middleware.concat(logger);
    },
  });

  return store;
};

export default { configureStore: configureAppStore, history };